import { toast } from 'react-toastify';
import { Button, Input, Spin, Modal } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { apiUrls } from '../../apiUrls.js';
import { useNavigate } from 'react-router-dom';
import { UnlockOutlined, LockOutlined, EditOutlined, SafetyCertificateOutlined, SearchOutlined } from '@ant-design/icons';
import HideSidebarInMobileMode from "../../components/HideSidebarInMobileMode.js";
import { getMemberAge } from '../../utils/memberAge.js';
const baseURL = apiUrls.baseURL;

const Guest = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [count, setCount] = useState(0);
    const [filter, setFilter] = useState({ skip: 0, limit: 20, search: "" });
    const [reload, setReload] = useState(false);
    const navigate = useNavigate();
    const [isShowChangeToTrialModalVisible, setIsShowChangeToTrialModalVisible] = useState(false);
    const [loadingChangeToTrial, setLoadingChangeToTrial] = useState(false);
    const [memberData, setMemberData] = useState({});

    useEffect(() => {
        if (!loadingMore) setLoading(true);
        fetchData()
    }, [reload])

    useEffect(() => {
        const loadNextPage = () => {
            const isNearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;
            const hasMore = data.length < count;

            if (isNearBottom && hasMore && !loading && !loadingMore) {
                setLoadingMore(true);
                setFilter((current) => ({ ...current, skip: current.skip + 1 }));
                setReload((current) => !current);
            }
        };

        window.addEventListener('scroll', loadNextPage);
        loadNextPage();
        return () => window.removeEventListener('scroll', loadNextPage);
    }, [data, count, loading, loadingMore, filter.skip]);

    const changeToTrial = async () => {
        setLoadingChangeToTrial(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            await axios.get(`${baseURL}/user/SetTrialMember?id=${memberData.memberId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            toast.success("با موفقیت ثبت شد", {
                position: 'bottom-right',
                autoClose: 3000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            refreshGuests()
            setIsShowChangeToTrialModalVisible(false)
            setLoadingChangeToTrial(false)
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoadingChangeToTrial(false);
        } finally {
            setLoadingChangeToTrial(false);
        }
    };

    const fetchData = async () => {

        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getGuestMembers?skip=${filter.skip}&limit=${filter.limit}&search=${filter.search}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;
            setCount(result.count)
            setData((current) => filter.skip === 0 ? result.items : [...current, ...result.items]);
            setLoading(false);
            setReload(false)
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
            setReload(false)
        } finally {
            setLoading(false);
            setLoadingMore(false);
            setReload(false)
        }
    };

    const refreshGuests = () => {
        setData([]);
        setLoading(true);
        setLoadingMore(false);
        setFilter((current) => ({ ...current, skip: 0 }));
        setReload((current) => !current);
    };

    return (
        <div>
            <HideSidebarInMobileMode />
            <div className="row-container members-list-search-row guest-members-search-row">

                <div className="members-list-search-icon"><SearchOutlined /></div>
                <Input className="members-list-search-input" placeholder='جستجو با نام، نام خانوادگی، کد ملی یا عنوان شغلی' onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        setData([]);
                        setLoading(true);
                        setFilter({ ...filter, skip: 0, limit: 5 });
                        setReload((current) => !current);
                    }

                }} onChange={(event) => setFilter({ ...filter, search: event.target.value })} style={{ marginTop: 5 }} size="large" />
            </div>
            <div className="members-total-count">
                <span>{'\u062a\u0639\u062f\u0627\u062f \u06a9\u0644 \u0627\u0639\u0636\u0627\u06cc \u0645\u0647\u0645\u0627\u0646'}</span>
                <strong>{count}</strong>
            </div>
            <div className="member-cards">
                {data.map((record) => (
                    <article key={record.id} className="member-card">
                        <div className="member-card-header">
                            {record.profilePhotoUrl
                                ? <a href={record.profilePhotoUrl} target="_blank" rel="noreferrer"><img className="member-card-photo" src={record.profilePhotoUrl} alt={`${record.firstName} ${record.lastName}`} /></a>
                                : <div className="member-card-photo member-card-photo-empty">—</div>}
                            <div className="member-card-name">
                                <strong>{record.firstName} {record.lastName}</strong>
                                {record.isDeaded && <span className="member-card-deceased">{'\u0645\u0631\u062d\u0648\u0645'}</span>}
                            </div>
                            {typeof record.isActive === 'boolean' && (
                                <div className={`member-card-account ${record.isActive ? 'member-card-account-active' : 'member-card-account-inactive'}`}>
                                    {record.isActive ? <UnlockOutlined /> : <LockOutlined />}
                                </div>
                            )}
                        </div>
                        <div className="member-card-details">
                            <span>{'\u0645\u0648\u0628\u0627\u06cc\u0644'}: {record.phoneNumber || '—'}</span>
                            <span>{'\u06a9\u062f \u0645\u0644\u06cc'}: {record.nationalCode || '—'}</span>
                            {getMemberAge(record.birthDay || record.birthDate) !== null && <span>{'\u0633\u0646'}: {getMemberAge(record.birthDay || record.birthDate)}</span>}
                        </div>
                        <div className="guest-member-card-actions">
                            <Button className="guest-member-trial-button" type="link" icon={<SafetyCertificateOutlined />} onClick={() => {
                                setIsShowChangeToTrialModalVisible(true)
                                setMemberData({ memberName: record.firstName + " " + record.lastName, memberId: record.id })
                            }}>{'\u062a\u0628\u062f\u06cc\u0644 \u0628\u0647 \u0622\u0632\u0645\u0627\u06cc\u0634\u06cc'}</Button>
                            <Button className="member-card-details-button" type="link" icon={<EditOutlined />} onClick={() => navigate('/members/detail/' + record.id)}>{'\u0645\u0634\u0627\u0647\u062f\u0647 \u067e\u0631\u0648\u0641\u0627\u06cc\u0644'}</Button>
                        </div>
                    </article>
                ))}
                {(loading || loadingMore) && <div className="member-cards-loading"><Spin /></div>}
                {!loading && data.length === 0 && <div className="member-cards-empty">{'\u0645\u0648\u0631\u062f\u06cc \u06cc\u0627\u0641\u062a \u0646\u0634\u062f'}</div>}
            </div>
            {loadingMore && <div className="members-wallet-load-more"><Spin size="small" /></div>}
            <Modal
                title={`تبدیل به آزمایشی ${memberData.memberName}`}
                open={isShowChangeToTrialModalVisible}
                closable={false}
                okButtonProps={null}
                footer={<div className='row-container'>
                    <Button onClick={() => setIsShowChangeToTrialModalVisible(false)} style={{ width: '100%' }}>بستن</Button>
                    <Button type="primary" loading={loadingChangeToTrial}
                        onClick={() => changeToTrial()}
                        style={{ width: '100%', marginRight: 10, backgroundColor: 'rgb(10, 23, 43)' }}>تایید</Button>
                </div>}
            >
                آیا از آزمایشی شدن این عضو مطمئن هستید؟
            </Modal>
        </div>
    )
}

export default Guest
